import React, { useEffect, useState } from 'react'
import {
  Avatar,
  Box,
  DialogContent,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Popover,
  Typography
} from '@material-ui/core'
import { getFullName, getValidDate } from 'lib/utils'
import { useContractStore } from 'context/ContractStore'
import { CollectionService } from 'lib/api/services/collection.service'
import { useAuthStore } from 'context/AuthStore'
import { useUserInfoStyles } from './DataDisplay.styles'
import FieldInfoNG from './FieldInfoNG'

const UserInfo = ({ avatar, fullName = '', phone = '' ,openTooltip=true}) => {
  const classes = useUserInfoStyles()
  const { authStore } = useAuthStore()
  const {
    contractStore: { contractAll, contract }
  } = useContractStore()

  const [anchorEl, setAnchorEl] = useState(null)
  const [addressData, setAddressData] = useState([])

  useEffect(() => {
    if (contract?.contractId) {
      getAddresses()
    }
  }, [contract?.contractId])

  const getAddresses = async () => {
    if (!contract?.contractId) {
      return
    }
    const res = await CollectionService.getAddresses(contract?.contractId)
    if (res?.data) {
      setAddressData(res?.data)
    }
  }
  const handleOpenPopover = event => {
    if(!openTooltip){setAnchorEl(null)}
    else setAnchorEl(event.currentTarget)
  }

  const handleClosePopover = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)

  return (
    <>
      <ListItem
        onClick={handleOpenPopover}
        alignItems="flex-start"
        disableGutters
        classes={{
          root: classes.root
        }}
        style={{ cursor: 'pointer' }}
      >
        <ListItemAvatar>
          <Avatar alt={'user_avatar_' + fullName} src={avatar} />
        </ListItemAvatar>
        <ListItemText
          primary={
            <Typography variant="subtitle1" className={classes.primaryTypography}>
              {fullName || ''}
            </Typography>
          }
          secondary={
            <Typography component="span" variant="body2" color="textSecondary">
              {phone}
            </Typography>
          }
        />
      </ListItem>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClosePopover}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        <DialogContent style={{ padding: 0, margin: 0 }}>
          <Box
            style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              gap: 10,
              borderRadius: 2,
              flexDirection: authStore.isMobile ? 'column' : 'row',
              maxHeight: authStore.isMobile ? '60vh' : 'auto',
              overflowY: authStore.isMobile ? 'auto' : 'visible'
            }}
          >
            <Avatar
              src={contractAll?.userPhoto}
              alt={contractAll?.client?.fullName}
              style={{
                width: '100%',
                maxWidth: authStore.isMobile ? '100%' : '240px',
                borderRadius: 0,
                height: 'auto',
                objectFit: 'contain'
              }}
            />

            <Box
              style={{
                width: 'fit-content',
                display: 'flex',
                flexDirection: 'column',
                padding: 8,
                gap: 1,
                alignItems: 'flex-start'
              }}
            >
              <Typography variant="subtitle1">
                {getFullName(
                  contractAll?.client?.lastName,
                  contractAll?.client?.firstName,
                  contractAll?.client?.patronymic,
                  contractAll?.client?.titleName
                )}
              </Typography>
              <Box
                style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: 8,
                  flexDirection: authStore.isMobile ? 'column' : 'row'
                }}
              >
                <Box
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: authStore.isMobile ? '100%' : 240,
                    gap: 0.5
                  }}
                >
                  <FieldInfoNG label={'Дата рождения:'} isVertical>
                    <Typography style={{ fontSize: 16, fontWeight: 600, wordBreak: 'break-word' }}>
                      {getValidDate(contractAll?.client?.birthDate)}
                    </Typography>
                  </FieldInfoNG>
                  <FieldInfoNG label={'Регистрация:'} isVertical>
                    <Typography style={{ fontSize: 16, fontWeight: 600, wordBreak: 'break-word' }}>
                      {addressData?.address?.addressR || addressData.registrationAddress?.addressR}
                    </Typography>
                  </FieldInfoNG>
                  <FieldInfoNG label={'Паспорт:'} isVertical>
                    <Typography style={{ fontSize: 16, fontWeight: 600, wordBreak: 'break-word' }}>
                      {contractAll?.client?.documentNumber || '-'}
                    </Typography>
                  </FieldInfoNG>
                </Box>
                <Box
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: authStore.isMobile ? '100%' : 240,
                    gap: 0.5
                  }}
                >
                  <FieldInfoNG label={'ИНН:'} isVertical>
                    <Typography style={{ fontSize: 16, fontWeight: 600, wordBreak: 'break-word' }}>
                      {contractAll?.client?.iin || '-'}
                    </Typography>
                  </FieldInfoNG>
                  <FieldInfoNG label={'Адрес проживания:'} isVertical>
                    <Typography style={{ fontSize: 16, fontWeight: 600, wordBreak: 'break-word' }}>
                      {addressData?.address?.addressL || addressData.registrationAddress?.addressL}
                    </Typography>
                  </FieldInfoNG>
                  <FieldInfoNG label={'Действителен:'} isVertical>
                    <Typography style={{ fontSize: 16, fontWeight: 600, wordBreak: 'break-word' }}>
                      {getValidDate(contractAll?.client?.closeDate)}
                    </Typography>
                  </FieldInfoNG>
                </Box>
              </Box>
            </Box>
          </Box>
        </DialogContent>
      </Popover>
    </>
  )
}
export default UserInfo
